import React, { useState }  from 'react'
import Message from './Message'
import styles from '../styles/Contact.module.css'

const Contact = () => {

    const [ firstName , setFirstName ] = useState('')
    const [ lastName , setLastName ] = useState('')
    const [ message , setMessage ] = useState('')
    const [ area , setArea ] = useState('')
    const [ email, setEmail ] = useState('')
    const [ contacts , setContacts ] = useState({firstName: '' , lastName: '', email: '',  message: '', area: '' , display: "none"})

    const handleSubmit = (e) => {
        e.preventDefault()
        let newContact = { 
            firstName: firstName, 
            lastName: lastName, 
            email: email,  
            area: area , 
            message: message, 
            display: 'block'
        }
        setContacts( newContact)
        clearForm()                
    }

    const clearForm = () => {
        setFirstName('')
        setLastName('')
        setEmail('')
        setArea('')
        setMessage('')
    }

    const handleClose = () =>{
        setContacts( { display: 'none' } )
    }

    return(
        <div className = {styles.container}>   

            <h1 className = {styles.h1} >Do you need Help?</h1> 

            <h2 className = {styles.h2}>If you have any questions, please fill out the form and we will get back with you.</h2>

            <form onSubmit = {handleSubmit}> 

                <input
                type = "text" 
                name = "firstName"
                placeholder = "First Name" 
                value = {firstName}
                required 
                onChange = {(e) => setFirstName(e.target.value)}/>

                <input 
                type = "text" 
                name = "lastName"
                placeholder = "Last Name"
                value = {lastName}
                required 
                onChange = {(e) => setLastName(e.target.value)}/>
                
                <input
                type = "email"
                name = "email"
                placeholder = "Email"
                value = {email}
                required
                onChange = {(e) => setEmail(e.target.value)}
                />

                <select 
                    name = "area" 
                    value = {area} 
                    required           
                    onChange = {(e) => setArea(e.target.value)}>                
                        <option value = "unknown">Select Area</option>
                        <option value = "Residential"> Residential</option>
                        <option value = "Commercial">Commercial</option>
                </select>
                
                <textarea 
                    name = "message" 
                    placeholder = "Do you have a question" 
                    value = {message} 
                    minLength = {10}
                    onChange = {(e) => setMessage(e.target.value)}            
                />     
                
                <button className = {styles.button}>Send</button>
     
            </form>
            
            <Message 
                firstName = {contacts.firstName} 
                lastName = {contacts.lastName} 
                area = {contacts.area}
                message = {contacts.message} 
                display = {contacts.display} 
                handleClose = {handleClose}/>
                
        </div>

    )

}

export default Contact